export default "__VITE_ASSET__1U9vz0F9__"